import { useLingui } from "@lingui/react/macro";
import { classNames } from "@offstreetparking/design-system/utils";
export type OverlayProps = {
	isVisible: boolean;
	onClick: () => void;
};
export const Overlay = ({ isVisible, onClick }: OverlayProps) => {
	const { t } = useLingui();
	return (
		<button
			type="button"
			aria-label={t`Close menu`}
			inert={!isVisible}
			className={classNames(
				"fixed inset-0 transition-all duration-500",
				isVisible ? "pointer-events-auto touch-none bg-overlay" : "pointer-events-none bg-overlay/0",
			)}
			onClick={isVisible ? onClick : undefined}
		/>
	);
};
